var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LoadingButton } from "@mui/lab";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useReadOnly } from "../utils/hooks/users/useReadOnly";
var DangerZone = function (_a) {
    var title = _a.title, description = _a.description, buttonLabel = _a.buttonLabel, onDelete = _a.onDelete, disabled = _a.disabled, loading = _a.loading, reloadOnDelete = _a.reloadOnDelete;
    var t = useTranslation().t;
    var readOnly = useReadOnly();
    var _b = useState(false), confirmOpen = _b[0], setConfirmOpen = _b[1];
    // A read-only user must never be able to trigger a delete, regardless of what
    // the consuming screen passes as `disabled`.
    var deleteDisabled = disabled || readOnly;
    return (_jsxs(Stack, __assign({ gap: 2 }, { children: [_jsx(Typography, __assign({ variant: 'h5', textAlign: 'start', color: 'error.main' }, { children: t('Danger zone') })), _jsx(Card, __assign({ variant: 'outlined', sx: function (theme) { return ({
                    borderColor: alpha(theme.palette.error.main, 0.3),
                }); } }, { children: _jsx(CardContent, __assign({ sx: {
                        p: 1.5,
                        '&:last-child': {
                            pb: 1.5,
                        },
                    } }, { children: _jsxs(Stack, __assign({ direction: 'row', justifyContent: 'space-between', alignItems: 'center', gap: 2 }, { children: [_jsx(Typography, __assign({ variant: 'body1', sx: { minWidth: 0 } }, { children: title })), _jsx(Button, __assign({ id: 'btn-danger-zone', variant: 'contained', color: 'error', startIcon: _jsx(DeleteOutlineIcon, {}), onClick: function () { return setConfirmOpen(true); }, disabled: deleteDisabled, sx: { textTransform: 'none', flexShrink: 0 } }, { children: buttonLabel }))] })) })) })), _jsxs(Dialog, __assign({ open: confirmOpen, onClose: function () { return setConfirmOpen(false); }, maxWidth: 'xs', fullWidth: true }, { children: [_jsx(DialogTitle, { children: title }), _jsx(DialogContent, { children: _jsx(Typography, __assign({ variant: 'body1', color: 'text.secondary' }, { children: description })) }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ onClick: function () { return setConfirmOpen(false); } }, { children: t('Cancel') })), _jsx(LoadingButton, __assign({ id: 'btn-danger-zone-confirm', color: 'error', variant: 'contained', loading: loading, disabled: deleteDisabled, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, (onDelete === null || onDelete === void 0 ? void 0 : onDelete())];
                                            case 1:
                                                _a.sent();
                                                if (reloadOnDelete) {
                                                    window.location.reload();
                                                    return [2 /*return*/];
                                                }
                                                setConfirmOpen(false);
                                                return [2 /*return*/];
                                        }
                                    });
                                }); } }, { children: t('Delete Now') }))] })] }))] })));
};
export default DangerZone;
